import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import store from 'store'
import Tabla from '../../components/Tabla'
import Dialogo from '../../components/DialogoInformacion'
import ModalCertificado from './ModalCertificado'
import { Alert } from '../../components/Alerta'

const getRangoMesActual = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const firstDay = `${year}-${month}-01`;
    const lastDayNum = new Date(year, today.getMonth() + 1, 0).getDate();
    const lastDay = `${year}-${month}-${String(lastDayNum).padStart(2, '0')}`;
    return { firstDay, lastDay };
};

class EmpresaResumen extends Component {
    constructor(props) {
        super(props);

        const rango = getRangoMesActual();
        this.state = {
            fecha_inicial: rango.firstDay,
            fecha_final: rango.lastDay,
            nit_empresa: '',
            nombre_empresa: '',
            columnastabla: [
                { name: "id", sortable: false, visible: false },
                { name: "nombre_negocio", text: "Empresa", sortable: true, visible: true },
                { name: "documentos_aceptados", text: "Aceptados", sortable: true, visible: true },
                {
                    name: "documentos_pendientes",
                    text: "Pendientes",
                    sortable: true,
                    visible: true,
                    render: (val) => {
                        const cantidad = Number(val || 0);
                        const esAlerta = cantidad > 10;
                        return (
                            <span 
                                className={esAlerta ? "text-danger font-weight-bold" : ""} 
                                style={esAlerta ? { color: '#dc3545' } : {}}
                            >
                                {val != null ? val : 0}
                            </span>
                        );
                    }
                },
                {
                    name: "documentos_error",
                    text: "Rechazados",
                    sortable: true,
                    visible: true,
                    render: (val) => {
                        const cantidad = Number(val || 0);
                        const esAlerta = cantidad > 0;
                        return (
                            <span 
                                className={esAlerta ? "text-danger font-weight-bold" : ""} 
                                style={esAlerta ? { color: '#dc3545' } : {}}
                            >
                                {val != null ? val : 0}
                            </span>
                        );
                    }
                },
                { name: "documentos_recibidos", text: "Recibidos", sortable: true, visible: true },
                {
                    name: "vence_certificado",
                    text: "Vencimiento Certificado",
                    sortable: true,
                    visible: true,
                    render: (val, row) => {
                        const diasVence = row && row.dias_vence_certificado != null && row.dias_vence_certificado !== ''
                            ? Number(row.dias_vence_certificado)
                            : null;
                        const esMenor30 = diasVence !== null && !isNaN(diasVence) && diasVence < 30;

                        if (row && (row.certificado_pendiente === true || row.certificado_pendiente === "true")) {
                            return (
                                <div>
                                    <span className="badge badge-warning text-dark font-weight-bold px-2 py-1 shadow-sm" 
                                          style={{ fontSize: '0.78rem', backgroundColor: '#ffc107', borderRadius: '4px' }} 
                                          title={`Nuevo certificado cargado pendiente de sincronización con el facturador. Vence nuevo: ${row.nuevo_vence_certificado || 'N/A'}`}>
                                        ⏳ Pendiente Sync
                                    </span>
                                    <div className={esMenor30 ? "text-danger mt-1 font-weight-bold" : "text-muted mt-1"} style={{ fontSize: '0.75rem' }}>
                                        Actual: <strong style={esMenor30 ? { color: '#dc3545' } : {}}>{val || 'N/A'}</strong>
                                        {esMenor30 && (
                                            <span className="ml-1" title={diasVence <= 0 ? 'Certificado vencido' : `Vence en ${Math.round(diasVence)} días`}>
                                                ({diasVence <= 0 ? 'Vencido' : `${Math.round(diasVence)}d`})
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        }

                        if (!val) {
                            return <span>Sin certificado</span>;
                        }

                        if (esMenor30) {
                            return (
                                <span 
                                    className="text-danger font-weight-bold" 
                                    style={{ color: '#dc3545' }}
                                    title={diasVence <= 0 ? 'Certificado vencido' : `Vence en ${Math.round(diasVence)} días`}
                                >
                                    {val}
                                    <span className="ml-1 small" style={{ fontSize: '0.8rem' }}>
                                        ({diasVence <= 0 ? 'Vencido' : `${Math.round(diasVence)}d`})
                                    </span>
                                </span>
                            );
                        }

                        return <span>{val}</span>;
                    }
                },
                {
                    name: "ultima_actualizacion",
                    text: "Ultima Actualizacion",
                    sortable: true,
                    visible: true,
                    render: (val, row) => {
                        const dias = (row && row.dias_ultima_actualizacion != null && row.dias_ultima_actualizacion !== '')
                            ? Number(row.dias_ultima_actualizacion)
                            : null;
                        const esMenorCero = dias !== null && !isNaN(dias) && dias < 0;

                        if (!val) {
                            return <span>N/A</span>;
                        }

                        if (esMenorCero) {
                            return (
                                <span 
                                    className="text-danger font-weight-bold" 
                                    style={{ color: '#dc3545' }}
                                    title={`Última actualización hace ${Math.abs(Math.round(dias))} días`}
                                >
                                    {val}
                                </span>
                            );
                        }

                        return <span>{val}</span>;
                    }
                },
                { name: "version", text: "Version", sortable: true, visible: true },
                {
                    name: "action", text: "", type: "action", visible: true, actions: [
                        { name: "ver_mas", icon: "pen", action: this.verMas, color: "blue" },
                        { name: "certificado", icon: "key", action: this.gestionarCertificado, color: "green" }
                    ]
                }
            ],
            itemstabla: [],
            configTabla: {
                full_count: 0,
                page: 0,
                orderby: "nombre_negocio",
                sort_order: "desc",
                limit: 10,
                totalPages: 0,
                isLoading: false
            }
        }
    }
    componentDidMount() {        
        this.eventoResumen()
    }
    dialogoVermas = (datos) => {
        console.log(datos)
        fetch(`${this.props.server}dashboardsa/empresa/resumen_dia_detalle?fechai=${this.state.fecha_inicial}&fechaf=${this.state.fecha_final}&empresa_id=${datos.empresa_id}`, {
            method: 'GET',
            headers: new Headers({
                'AuthorizationSa': store.get('data').token,
                'email': store.get('data').usuario.email,
                'pin': store.get('data').pin,
            })
        }).then(res => {
            return res.json()
        }).then(data => {
            console.log(data)
            this.dialogo.open(data)
        }).catch(error => { console.error(error) })

    }
    gestionarCertificado = (empresa) => {
        if (this.modalCertificado) {
            this.modalCertificado.open(empresa);
        }
    }

    verMas = (datos) => {
        this.setState({
            tituloDialogo: "Ver mas Resumen Empresa"
        }, this.dialogoVermas(datos))
    }
    onInputChangeDialog = () => { }

    cerrandoDialogoUsuario = () => {
        this.eventoResumen()
    }
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    sumitFormConsulta = (event) => {
        event.preventDefault();
        this.setState({ configTabla: { ...this.state.configTabla, page: 0 } }, () => {
            var datos = { config: this.state.configTabla }
            this.eventoResumen()
        })
    }
    getDate = () => {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        //return `${month}/${date}/${year}`;
        return `${year}-${month}-${date}`;
    }
    eventoResumen = () => {
        var datos = { config: this.state.configTabla }
        this.getResumenEmpresas(datos)
    }
    getResumenEmpresas = (datos) => {
        console.log(datos)
        fetch(`${this.props.server}dashboardsa/empresa/resumen_dia?limit=${datos.config.limit}&page=${datos.config.page}&orderby=${datos.config.orderby}&sort_order=${datos.config.sort_order}&fechai=${this.state.fecha_inicial || ""}&fechaf=${this.state.fecha_final || ""}&nit_empresa=${this.state.nit_empresa || ""}&nombre_empresa=${encodeURIComponent(this.state.nombre_empresa || "")}`, {
            method: 'GET',
            headers: new Headers({
                'AuthorizationSa': store.get('data').token,
                'email': store.get('data').usuario.email,
                'pin': store.get('data').pin,
            })
        }).then(res => {
            return res.json()
        }).then(data => {
            console.log(data)
            const { datos, limit, page, full_count, orderby, sort_order } = data
            const totalPages = Math.ceil(full_count / limit)
            this.setState({
                itemstabla: datos,
                configTabla: {
                    full_count: full_count,
                    page: page,
                    orderby: orderby,
                    sort_order: sort_order,
                    limit: limit,
                    totalPages: totalPages,
                    isLoading: false
                }
            })
        }).catch(error => { console.error(error) })
    }

    render() {
        const { isLoading } = this.state;
        const factual = this.getDate;
        return (
            <div className="container-fluid" >
                <h1 className="mt-4">Resumen Empresas</h1>
                <div className="my-2 text-white form-busqueda">
                    <form className="p-2" onSubmit={this.sumitFormConsulta}>
                        <div className="form-row align-items-center">
                            <div className="form-group form-group-sm col-auto">
                                <label htmlFor="inputIdentifica">Fecha Inicial</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="inputFechai"
                                    placeholder="Fecha Inicial"
                                    name="fecha_inicial"
                                    value={this.state.fecha_inicial}
                                    onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group form-group-sm col-auto">
                                <label htmlFor="inputRazon">Fecha Final</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="inputFechaf"
                                    placeholder="Fecha Final"
                                    name="fecha_final"
                                    value={this.state.fecha_final}
                                    onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group form-group-sm col-auto">
                                <label htmlFor="inputRazon">Nit Empresa</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="inputNitEmpresa"
                                    placeholder="Nit Empresa"
                                    name="nit_empresa"
                                    value={this.state.nit_empresa}
                                    onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group form-group-sm col-auto">
                                <label htmlFor="inputNombreEmpresa">Nombre Empresa</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="inputNombreEmpresa"
                                    placeholder="Buscar por Nombre"
                                    name="nombre_empresa"
                                    value={this.state.nombre_empresa}
                                    onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group form-group-sm col-auto">
                                <label htmlFor="button">&nbsp;</label>
                                <button type="submit" className="btn btn-primary btn-sm form-control " id="button" disabled={isLoading}>
                                    {isLoading &&
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="false"></span>}
                                    &nbsp;Consultar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-xl">
                    <Tabla
                        config={this.state.configTabla}
                        columnas={this.state.columnastabla}
                        documentos={this.state.itemstabla}
                        traerDatos={this.getResumenEmpresas} />
                </div>
                <Dialogo
                    title={this.state.tituloDialogo}
                    ref={element => { this.dialogo = element }}
                />
                <ModalCertificado
                    server={this.props.server}
                    ref={element => { this.modalCertificado = element }}
                    onSuccess={this.eventoResumen}
                />
            </div>
        )
    }

}
export default EmpresaResumen
